
export type MetaTagsConfig = {
  title: string;
  description: string;
  ogImage?: string;
  ogUrl?: string;
  twitterCard?: string;
};

// Default meta tags that will be used if specific route config is not found
export const defaultMetaTags: MetaTagsConfig = {
  title: "Metrade - Trading Strategy Marketplace",
  description: "The largest marketplace for verified trading strategies",
  ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
  ogUrl: "https://metrade.io",
  twitterCard: "summary_large_image",
};

// Route-specific meta tags - extend as needed for various routes
export const routeMetaTags: Record<string, MetaTagsConfig> = {
  "/": {
    title: "Metrade - Trading Strategy Marketplace",
    description: "The largest marketplace for verified trading strategies",
    ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
    ogUrl: "https://metrade.io",
  },
  "/marketplace": {
    title: "Marketplace - Metrade",
    description: "Explore and invest in verified crypto trading strategies",
    ogUrl: "https://metrade.io/marketplace",
    ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
  },
  "/strategies": {
    title: "Premium Strategies - Metrade",
    description: "Discover our premium trading strategies for optimal returns",
    ogUrl: "https://metrade.io/strategies",
    ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
  },
  "/pricing": {
    title: "Pricing Plans - Metrade",
    description: "Affordable premium plans for copy trading strategies",
    ogUrl: "https://metrade.io/pricing",
    ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
  },
  "/about-us": {
    title: "About Us - Metrade",
    description: "Learn about Metrade and our mission to democratize trading strategies",
    ogUrl: "https://metrade.io/about-us",
    ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
  },
  "/knowledge-hub": {
    title: "Knowledge Hub - Metrade",
    description: "Educational resources and guides for crypto trading",
    ogUrl: "https://metrade.io/knowledge-hub",
    ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
  },
  "/landing/phemex": {
    title: "Phemex + METRADE | Professional Trading Strategies",
    description: "Access professional trading strategies with METRADE and Phemex. Trade smarter with verified strategies and expert support.",
    ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
    ogUrl: "https://metrade.io/landing/phemex",
  },
  "/landing/okx": {
    title: "OKX + METRADE | Professional Trading Strategies",
    description: "Access professional trading strategies with METRADE and OKX. Trade smarter with verified strategies and expert support.",
    ogImage: "https://metrade.io/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png", // Updated to absolute URL
    ogUrl: "https://metrade.io/landing/okx",
  },
};
